import { BasicProduct } from '@/types';
import { create } from 'zustand';

interface ProductStore {
  products: BasicProduct[];
  setProducts: (products: BasicProduct[]) => void;
  resetProducts: () => void;
  isProductListValid: boolean;
  setIsProductListValid: (isValid: boolean) => void;
  submitAttempted: boolean;
  setSubmitAttempted: (attempted: boolean) => void;
}

const emptyProduct: BasicProduct = { title: '', quantity: '1', price: '' };

const useProductStore = create<ProductStore>((set) => ({
  products: [emptyProduct],
  isProductListValid: true, // by default is valid, it will be change to false if after submitting products is empty
  setIsProductListValid: (isValid: boolean) => set({ isProductListValid: isValid }),
  submitAttempted: false,
  setSubmitAttempted: (attempted: boolean) => set({ submitAttempted: attempted }),
  setProducts: (products) => set({ products }),
  resetProducts: () => set({ products: [{ ...emptyProduct }], submitAttempted: false }),
}));

export default useProductStore;
